// removed by extract-text-webpack-plugin
module.exports = {"Content":"Layout__Content__3pLYC","Home":"Layout__Home__AWwAT","BkgOverlay":"Layout__BkgOverlay__3mb5t","RedCircle":"Layout__RedCircle__VaC6u","ReminderSection":"Layout__ReminderSection__1cpoO","ChatShadow":"Layout__ChatShadow__1-9Q_","ChatContainer":"Layout__ChatContainer__1y3bS","ChatModeOn":"Layout__ChatModeOn__3WtNs","ChatModeOff":"Layout__ChatModeOff__1U6NS","ModalBtnGroup":"Layout__ModalBtnGroup__17EZQ"};


//////////////////
// WEBPACK FOOTER
// ./src/hoc/Layout/Layout.css
// module id = 321
// module chunks = 0